import { Component } from '@angular/core';
import { AppConst } from '@app/App.const';
import { SettingsService } from '@app/shared/common/services/Authentication/settings.service';
import { CommonMethodsService } from '@app/shared/common/services/common-methods.service';


@Component({
  selector: 'app-privacy-notice',
  templateUrl: './privacy-notice.component.html',
  styleUrl: './privacy-notice.component.scss',
  standalone:false
})
export class PrivacyNoticeComponent {
  constructor(
    private settingsService:SettingsService,
    private commonService:CommonMethodsService
  ){
  }
  public scrolledToBottom:boolean=false;

  public acceptPrivacyPolicy(){
    this.commonService.acceptPrivacyPolicy()
  }
  public rejectPrivacyPolicy(){
    this.settingsService.logoff();
  }
  public onScroll(event:any): void {
    const element = event.target;
    const atBottom = element.scrollHeight - element.scrollTop - element.clientHeight;
    // Below if will make sure that once user has scrolled to the bottom of notice, Accept button will be available even after sroll up
    if(!this.scrolledToBottom){
      this.scrolledToBottom = atBottom <5 && atBottom > -5 ? true : false;// Giving a range to mark as end of scroll
    } 
  }
}
